import React, {useState} from 'react'
import styled from 'styled-components'
// import { BiTrash,BiUserPlus} from 'react-icons/bi'
import { requestTranslation } from '@futures-platform/i18n'
import { PUBLIC_URL } from '../../env'
import PublicLink from '../PublicLink/PublicLink'
import {paddingModalStyles, modalStyles} from '@futures-platform/ui'
import {Modal as ModalSangre, PopupContainer} from '@futures-platform/ui'
// import { AiFillQuestionCircle,AiOutlineUndo } from "react-icons/ai";
import InformationModal from '../InformationModal/InformationModal'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import InformationIcon from '../InfoIcon'
import Popover from '@material-ui/core/Popover';
import { makeStyles, 
    // createStyles, 
    // Theme 
  } from '@material-ui/core/styles';
  import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserPlus } from '@fortawesome/free-solid-svg-icons'

const useStyles = makeStyles(theme => ({
    popover: {
      pointerEvents: 'none',
      width: '40%'
    },
    paper: {
      padding: theme.spacing(1),
      backgroundColor: '#424242',
      color: '#fff',
      width: 'fit-content'
    },
    
  }));

const ShareLinkExistedModal = ({isPublicShareUrlEnabled, expiredTime, openPublicLinkModal, isGroupOWnerOrCoordinator, radarSettings, requestClose, userInfo,
  isRolesToShowPublicSharedLink,
  isModalOpen,
  onRequestClose,
  publicURL,
  openConfirmationModal,
  openDeleteConfirmationModal,
  publicLinkModalWhenParamURLIs1,
  public_shared_group_setting,
  checkPublicLinkExsited
}) => {
  const classes = useStyles()
  const [ratingDescriptionDisplayed, setRatingDescriptionDisplayed] = useState(false)
  const [ratingAnchorEl, setRatingAnchorEl] = useState(null);
  const [isShareRadarHubpotFormOpened, setisShareRadarHubpotFormOpened] = useState(false);
  const params = new URLSearchParams(window.location.search)
  const radar = Number(params.get('node'))

  const [openRatingInformationModal, setOpenRatingInformationModal] = useState(false)
    const onHoverRatingIcon = (event) => {
        setRatingAnchorEl(event.currentTarget)
        setRatingDescriptionDisplayed(true)
    }
    
      const onLeaveRatingIcon = () => {
        setRatingAnchorEl(null)
        setRatingDescriptionDisplayed(false)
      }
    
      const openRatingInformationModalHandle = () => {
        setOpenRatingInformationModal(() => true)
    }
    const closeRatingInformationModalHandle = () => {
        setOpenRatingInformationModal(false)
    }
    const openRequestSharedRadarHubpotFormHandler = () => {
      setisShareRadarHubpotFormOpened(() => !isShareRadarHubpotFormOpened)
    }
    const closeRequestSharedRadarHubpotFormHandler = () => {
      setisShareRadarHubpotFormOpened(() => false)
    }
  return (
    <Modal>
      <div className="modal-form-sections" style={{background: 'white !important'}}>
        <div className="modal-form-section modal-form-header">
          <ModalHeader>
            {requestTranslation("ShareRadar")} <InformationIcon
                                onMouseEnter={onHoverRatingIcon} 
                                onMouseLeave={onLeaveRatingIcon}
                                onClick={openRatingInformationModalHandle}
                            />
                            <Popover 
                                className={classes.popover}
                                classes={{
                                    paper: classes.paper,
                                }}
                                open={ratingDescriptionDisplayed || false}
                                anchorEl={ratingAnchorEl} 
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                                }}
                                onClose={onLeaveRatingIcon}
                                disableRestoreFocus
                            >
                                <HoverBox>{(radarSettings?.radarLanguage === "en" ? 'More information on Sharing' : 'Lisätietoja jakamisesta') || requestTranslation('HoverSharingInfo')}</HoverBox>
                            </Popover>

                            <InformationModal 
                                  InfoModalHeader={requestTranslation('Sharingtheradar')}
                                  InfoModalTitleNote={requestTranslation('Theradarcanbesharedintwoways')}
                                  InfoModalOpen={openRatingInformationModal}
                                  InfoModalClose={closeRatingInformationModalHandle}
                                  // LearnMoreBtn={requestTranslation('LearnMoreVotingBtn')}
                                  // GuideBtn={requestTranslation('GuideVotingBtn')}
                                  // LearnMoreLink='https://info.futuresplatform.com/hub/how-to-vote'
                                  // GuideLink='https://info.futuresplatform.com/hub/how-to-orginise-voting'
                                  InfoModalNote={requestTranslation('UserManagementDescriptionLabel')}
                                  InfoModalDescription={requestTranslation('UserManagementDescription1')}
                                  InfoModalDescription2={requestTranslation('UserManagementDescription2')}
                                  InfoModalDescription3={requestTranslation('UserManagementDescription3')}
                                  InfoModalDescription4={requestTranslation('UserManagementDescription4')}
                                  InfoModalNote2={requestTranslation('RequestSharedLinkLabel')}
                                  InfoModalDescriptiona={requestTranslation('RequestSharedLink1')}
                                  InfoModalDescriptionb={requestTranslation('RequestSharedLink2')}
                                  InfoModalDescriptionc={requestTranslation('RequestSharedLink3')}
                                  InfoModalDescriptiond={requestTranslation('RequestSharedLink4')}
                                  // InfoModalDescription2Italic={requestTranslation('RequestSharedLink5')}
                              />
          </ModalHeader>
          <ModalText>
           {requestTranslation('ShareRadar2Ways')}
          </ModalText>
        </div>
       
        <div className="modal-form-section" style={{paddingTop: '4px'}}>
          <Modalbox>
            <ModalHeaderP>   
              <UserIconWrapper><FontAwesomeIcon icon={faUserPlus} /></UserIconWrapper>
              <div>{requestTranslation('InviteUsers2Radars')}</div>
            </ModalHeaderP>   
            <ModalText>
            {requestTranslation('InviteUsers2RadarsDescription')}
            </ModalText>
            <ModalAnchor href={`${PUBLIC_URL}/radarusers?gid=${radarSettings?.group?.id}&invite=${radarSettings?.radar_id}`}>{requestTranslation('goToManagement')}</ModalAnchor>
          </Modalbox>
        </div>
        <div className="modal-form-section" style={{color:'gray', paddingTop: '0', paddingBottom: 0, background: 'white'}}>
          <BorderBottomLine><span>{requestTranslation('Or')}</span></BorderBottomLine>
        </div>
        <div className="modal-form-section" style={{paddingTop: '4px', paddingBottom: 0}}>
          {
            !!isGroupOWnerOrCoordinator && (
              <Modalbox>
                <PublicLink
                  checkPublicLinkExsited={checkPublicLinkExsited}
                  public_shared_group_setting={public_shared_group_setting}
                  isPublicShareUrlEnabled={isPublicShareUrlEnabled}
                  expiredTime={expiredTime}
                  openPublicLinkModal={openPublicLinkModal}
                  isGroupOWnerOrCoordinator={isGroupOWnerOrCoordinator}
                  isExtraModalFormSectionsClass={true}
                  isNotModal={true}
                  isRolesToShowPublicSharedLink={isRolesToShowPublicSharedLink}
                  isModalOpen={isModalOpen}
                  onRequestClose={onRequestClose}
                  publicURL={publicURL}
                  openConfirmationModal={openConfirmationModal}
                  openDeleteConfirmationModal={openDeleteConfirmationModal}
                />
              </Modalbox>
              )
          }
        </div>
        <div className="modal-form-section" style={{ background: 'white'}}>
          <CancelButton
                onClick={requestClose}
            > {requestTranslation('Close')} </CancelButton>
        </div>
       </div>
    </Modal>
  )
}

export default ShareLinkExistedModal

export const HoverBox = styled.p`
    display: flex;
    flex-wrap: wrap;
    width: fit-content;
    justify-content: center;
    align-items: center;
    align-content: center;
    margin: auto; 
`

const Modal = styled.div`
background: white;
// margin-top: 2% !important;
// max-width: 82%;
margin-right: auto;
margin-left:auto;
font-size: 1.2rem;
// padding: 4% 4% 2% 4%;
width:fit-content;

/* @media screen and (max-width:960px){
    margin-left:auto;
    margin-right: auto;
    font-size: 1.8rem;
} */
`

const ModalHeader = styled.h2`
color:black;
`

const ModalText= styled.p`
color: black;
font-size: 14px;
margin-top:20px;
width: fit-content;

`

const CancelButton= styled.button`
color: grey;
font-size: 16px;
font-weight: 700;
margin-top:20px;
width: fit-content;
display: block;
margin-left: auto;
 &:hover {
    color: #006998;
 }
`

const Modalbox = styled.div`
 box-shadow: 0 0 10px #A9A9A9;
 margin-top: 25px;
 margin-bottom: 25px;
//  color: lightgray;
 border: 0.25px solid lightgray;
 padding:20px;
 width:fit-content;
`

const ModalNextBox = styled.div`
box-shadow: 0 0 10px #A9A9A9;
margin-top: 25px;
color: lightgray;
border: 0.25px solid;
padding:20px;
width: 100%;
`



const ModalHeaderP = styled.div`
color:black;
font-size:16px;
display: flex;
align-items:center;
font-weight: bold;
`

// const ModalIcon = styled(BiUserPlus)`
// margin-top: 2px;
// margin-right: 10px
// `

const ModalAnchor = styled.a`
background-color: white;
border: 1px solid #006998;
color: #006998 !important;
padding: 6px;
text-align: center;
-webkit-text-decoration: none;
text-decoration: none;
display: inline-block;
font-size: 14px;
margin: 4px 2px;
border-radius: 30px;
font-weight: bold;
margin-left: auto;
display: block;
margin-top: 5%;
cursor: pointer;
width: fit-content;
padding-left: 20px;
padding-right: 20px;
&: hover {
  -webkit-text-decoration: none;
  text-decoration: none;
  background-color: #e8ebeb !important;
}
`
const ModalButton = styled.button`
  background-color: white; /* Green */
  border: 1px solid blue;
  color: #5c5cb9;
  padding: 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 12px;
   margin: 4px 2px;
   border-radius: 30px;
   border-color:#5c5cb9;
   font-weight:bold;
   margin-left:auto;
   display: block;
   margin-top:5%;
   cursor:pointer;
`
  /* <------- -------> */

const ModalHeaderShare = styled.h3`
color:black;
font-size:12px;
margin-top:20px;
`
const ModalShare = styled.div`
 /* display: grid;
 grid-template-columns: 75% 50%;
 width: fit-content */
 display:flex;
 justify-content: space-between;
`

const ModalInput = styled.input`
  margin: 16px 0;
  width: 72%;
`
const ModalButtonShare = styled.button`
  background-color: white; /* Green */
  border: 1px solid blue;
  color: #5c5cb9;
  padding: 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 15px;
   margin: 4px 2px;
   border-radius: 30px;
   border-color:#5c5cb9;
   font-weight:bold;
   width: fit-content;
   display: block;
   margin-top:5%;
   cursor:pointer;
   margin-top: auto;
   margin-bottom:auto;
   
`

const ModalTextShare = styled.a`
 /* display: grid;
 grid-template-columns: 75% 50%;
 width: fit-content */
 display:grid;
 grid-template-columns: 0.8fr 4.25fr 1fr;
 margin-top:-26px;
`
// const ModalIconTrash = styled(BiTrash)`
//  /* display: grid;
//  grid-template-columns: 75% 50%;
//  width: fit-content */
//  font-size:12px;
//  margin:auto;
// `

  /* <------- -------> */

  const ModalRequestedDivided= styled.div`
 
 margin-top: 23px;
`


const ModalRequested= styled.div`
 display:flex;
 margin-top: 12px;
`

const ModalRequestedText= styled.p`
 flex-direction: column;
 font-size: 12px;
 margin-left:3px;
`

const ModalRequestedHeader= styled.h3`
 font-size: 16px;
 margin-top: 20px;

`

const ModalRequestShared= styled.div`
background: white;
margin-top: 2% !important;
max-width: 82%;
margin-right: auto;
margin-left:auto;
font-size: 1.2rem;
padding: 4% 4% 2% 4%;
width: 100%;

/* @media screen and (max-width:960px){
    margin-left:auto;
    margin-right: auto;
    font-size: 1.8rem;
} */
`

const ModalForm= styled.textarea`
  width: 100%;
  height: 150px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 16px;
  resize: none;
`
const ModalRequestedButton = styled.button`
  background-color: #10ca86;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  resize: none;
  font-size: 16px;

`
const ModalRequestedButtonCancel = styled.label`
  padding: 12px 20px;
  cursor: pointer;
  resize: none;
  font-size: 16px;
  border:none;
  background-color: none;
  color: gray;
`

const BorderBottomLine = styled.p`
  width: 100%; 
  text-align: center; 
  border-bottom: 1px dotted #000; 
  line-height: 0.1em;
  margin: 10px 0 20px;
  margin-top: 30px;
  margin-bottom: 30px;
  & span {
    background:#fff; 
    padding:0 20px; 
  } 
`

const UserIconWrapper = styled.div`
color: white;
background: gray;
border-radius: 20px;
width: 30px;
height: 30px;
display: flex;
justify-content: center;
align-items: center;
margin-right: 12px;
font-size: 14px;

`